import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { LocationService } from '../../../location.service';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
  imports: [MatIcon, RouterLink],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BannerComponent {

  router = inject(LocationService);

  selectedBanner: string = 'old/homev2/home-categories.webp';

  referDownload() {
    this.router.navigate(['/get-the-app']);
   }

   referPremium() {
    // this.router.navigate([this.auth.premiumRoute]);
   }
}
